import {z} from 'zod';

import {isNotNil} from 'ramda';

import {CheckoutProfileErrorResponseSchema, type CheckoutProfileError} from '../types';

const apiErrorSchema = z.object({data: CheckoutProfileErrorResponseSchema});
const isListError = (error: CheckoutProfileError) =>
  isNotNil(error.checkoutProfileId) ||
  isNotNil(error.missing) ||
  isNotNil(error.rules) ||
  error.path === '';

export function getCheckoutProfileErrors(error: unknown) {
  const parsed = apiErrorSchema.safeParse(error);

  if (!parsed.success) {
    return null;
  }

  const errors = parsed.data.data.errors;

  return {
    errors,
    fieldErrors: errors
      .filter((item) => !isListError(item))
      .map((item) => ({
        field: item.path.replace(/\[(\d+)\]/g, '.$1'),
        message: item.message,
        code: item.code,
      })),
    listErrors: errors.filter(isListError),
  };
}
